export default {"src":"/_next/static/media/stablecoin.052659ba.svg","height":131,"width":128,"blurWidth":0,"blurHeight":0};